import React from 'react'
import { connect } from 'react-redux'
import { getBaseURL } from '../../../../../lib/util'

class PrivacyPolicy extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { terms } = this.props,
      baseUrl = getBaseURL()

    return (
      <div>
        <div className='settings-units-container' style={{
          height: 'calc(100vh - 160px)',
          // overflowY: 'auto'
        }}>
          <iframe
            style={{
              width: '100%',
              height: '100%',
              filter: 'invert(0.6)'
            }}
            src={`${baseUrl}/privacy_policy.html`}></iframe>
        </div>
      </div >
    )
  }
}


const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(PrivacyPolicy)